<template>
  <el-row :gutter="15">
    <el-col
      class="text-left"
      :span="24"
    >
      <el-dropdown
        class="px-2"
        size="small"
        @command="setDateRange"
      >
        <span>
          <FontAwesomeIcon
            :icon="['fas', 'caret-down']"
            size="lg"
            fixed-width
          />
        </span>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            command="week"
            :disabled="dateRange === 'week'"
          >
            This Week
          </el-dropdown-item>
          <el-dropdown-item
            command="month"
            :disabled="dateRange === 'month'"
          >
            This Month
          </el-dropdown-item>
          <el-dropdown-item
            command="quarter"
            :disabled="dateRange === 'quarter'"
          >
            Quarter-to-date
          </el-dropdown-item>
          <el-dropdown-item
            command="year"
            :disabled="dateRange === 'year'"
          >
            Year-to-date
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <span
        class="align-middle"
        style="display: inline-block;"
      >
        <small class="font-italic">Current Period: {{ dateFrom | moment('D MMMM YYYY') }}&nbsp;<i>-</i>&nbsp;{{ dateTo | moment('D MMMM YYYY') }}</small><br>
        <small class="font-italic">Previous Period: {{ previousDateFrom | moment('D MMMM YYYY') }}&nbsp;<i>-</i>&nbsp;{{ previousDateTo | moment('D MMMM YYYY') }}</small>
      </span>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    dateRange: {
      type: String,
      required: true
    }
  },
  computed: {
    dateFrom () {
      return this.$moment().startOf(this.dateRange)
    },
    dateTo () {
      return this.$moment().endOf('day')
    },
    previousDateFrom () {
      const dateFrom = this.dateFrom

      return dateFrom.clone().subtract(1, this.dateRange).startOf('day')
    },
    previousDateTo () {
      const dateTo = this.dateTo

      return dateTo.clone().subtract(1, this.dateRange).endOf('day')
    }
  },
  methods: {
    setDateRange (value) {
      this.$emit('update:dateRange', value)
    }
  }
}
</script>
